/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INodeProps, Module, Node } from '@msdyn365-commerce-modules/utilities';
import { HtmlHeadInclude } from '@msdyn365-commerce/core';
import * as React from 'react';

import { ISearchFormViewProps } from './components';
import { ISearchViewProps } from './unbxd-search';

// const defaultUnbxdAutosuggestJs = 'https://sandbox.unbxd.io/stage-henrys-com700951507546414_autosuggest.js';
// const defaultUnbxdAutosuggestCss = 'https://sandbox.unbxd.io/stage-henrys-com700951507546414_autosuggest.css';

const SearchView: React.FC<ISearchViewProps> = props => {
    const {
        Search,
        AutoSuggestAriaLabel,
        AutoSuggestAriaLabelText,
        searchText,
        AutoSuggest,
        form,
        SearchForm,
        FormWrapper,
        label,
        unbxdAutosuggestJs,
        unbxdAutosuggestCss
    } = props;

    const jsUri = props.context.app.config.heiUnbxdAutosuggestJs ?? unbxdAutosuggestJs;
    const cssUri = props.context.app.config.heiUnbxdAutosuggestCss ?? unbxdAutosuggestCss;

    process.env.NODE_ENV === 'development' && console.log('Unbxd', 'SearchView', jsUri, cssUri);

    return (
        <Module {...Search}>
            {label}
            {_renderForm(form as ISearchFormViewProps, SearchForm, FormWrapper, jsUri, cssUri)}
            <Node {...AutoSuggest}>
                {searchText && searchText.length > 0 ? <Node {...AutoSuggestAriaLabel}>{AutoSuggestAriaLabelText}</Node> : ''}
            </Node>
        </Module>
    );
};

const _renderForm = (
    form: ISearchFormViewProps,
    SearchForm: INodeProps,
    FormWrapper: INodeProps,
    unbxdAutosuggestJs: string | undefined,
    unbxdAutosuggestCss: string | undefined
) => {
    return (
        <Node {...SearchForm}>
            <Node {...FormWrapper}>
                {form.input}
                {/* {form.cancelBtn} */}
                {form.submitBtn}
            </Node>

            <HtmlHeadInclude>
                {unbxdAutosuggestJs && <script data-load-point='bodyEnd' src={unbxdAutosuggestJs} />}
                {unbxdAutosuggestCss && <link data-load-point='headEnd' rel='stylesheet' href={unbxdAutosuggestCss} />}
            </HtmlHeadInclude>
        </Node>
    );
};

export default SearchView;
